// The onSubmit handler can return either void or Promise<void | T>, which triggers
// the no-misused-promises rule when passed to form.handleSubmit. This is a false positive
// since react-hook-form properly handles both synchronous and asynchronous submit handlers.
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { FormProvider } from 'react-hook-form';
import { FormProps } from '../../../types/fileExplorerTypes';
import { RenameFileSchema } from './schemas';
import { InputField } from '../../Forms/Fields';

export function RenameFileForm({ form, onSubmit, children }: FormProps<RenameFileSchema>) {
  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="modal-form">
        <InputField<RenameFileSchema>
          id="title"
          path="title"
          label="Nombre"
          placeholder="Nombre del archivo"
          required
        />
        {children}
      </form>
    </FormProvider>
  );
}
